/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getRewardJackpot, getRewardRecord } from "./action"

interface initialStateType {
  loadingJackpot: boolean
  jackpot: any
  errorJackpot: string
  loadingRecord: boolean
  record: any
  errorRecord: string
}

const initialState: initialStateType = {
  loadingJackpot: false,
  jackpot: {},
  errorJackpot: "",
  loadingRecord: false,
  record: {},
  errorRecord: ""
}

export const jackpotSlice = createSlice({
  name: 'jackpot',
  initialState,
  reducers: {},
  extraReducers: {
    //get reward jackpot
    [getRewardJackpot.pending.type]: (state) => {
      state.loadingJackpot = true
      state.jackpot = {}
    },

    [getRewardJackpot.fulfilled.type]: (state, action: PayloadAction<any>) => {
      state.loadingJackpot = false;
      state.errorJackpot = "";
      state.jackpot = action.payload;
    },
    
    [getRewardJackpot.rejected.type]: (state, action: PayloadAction<string>) => {
      state.loadingJackpot = false;
      state.errorJackpot = action.payload;
    },

    //get new record
    [getRewardRecord.pending.type]: (state) => {
      state.loadingRecord = true
      state.record = {}
    },

    [getRewardRecord.fulfilled.type]: (state, action: PayloadAction<any>) => {
      state.loadingRecord = false;
      state.errorRecord = "";
      state.record = action.payload;
    },
    
    [getRewardRecord.rejected.type]: (state, action: PayloadAction<string>) => {
      state.loadingRecord = false;
      state.errorRecord = action.payload;
    }
  },
})

export default jackpotSlice.reducer
